module.exports = __webpack_public_path__ + "static/pigly03-f5a2f5e9315fc443e49fb68be31c5d04.png";